import React from 'react'
import './InfoPanel.css'

class InfoPanel extends React.Component {
  render () {
    return (
      <div className="infoPanel">
        Source available at&nbsp;
        <a href="https://github.com/fwouts/instant" target="_blank">https://github.com/fwouts/instant</a>
      </div>
    )
  }
}

export default InfoPanel



// WEBPACK FOOTER //
// ./src/InfoPanel.js